var _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _rect4, _circle, _text5, _rect5, _path, _path2, _path3, _circle2, _text6, _text7, _rect6, _circle3, _text8, _text9, _rect7, _circle4, _text0, _text1, _rect8, _circle5, _text10, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreFuelIntelligenceAnomalyDetectionDashboardMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 390,
    height: 720,
    viewBox: "0 0 390 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore mobile fuel intelligence dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 720,
    rx: 30,
    fill: "#07152A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 388,
    height: 718,
    rx: 29,
    fill: "none",
    stroke: "#284260",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 42,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    textAnchor: "start",
    letterSpacing: 1.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    dy: 0
  }, "FUEL INTELLIGENCE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 79,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 830,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    dy: 0
  }, "Consumption exception"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 108,
    width: 342,
    height: 104,
    rx: 18,
    fill: "#0F2847",
    stroke: "#2A4666"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 139,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 750
  }, "VEHICLE FC\u20132047")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 181,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 850
  }, "+14.8%")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 141,
    width: 104,
    height: 38,
    rx: 19,
    fill: "#3A1730"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 160,
    r: 5,
    fill: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 164,
    fill: "#FF8DB8",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "REVIEW")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 232,
    width: 342,
    height: 240,
    rx: 18,
    fill: "#0A213D",
    stroke: "#2A4666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 420C82 378 101 396 131 349S185 377 216 306s64 50 122-31",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 366C88 351 107 366 140 334s55 31 83-15 60 7 115-20",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "7 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 278V432H340",
    fill: "none",
    stroke: "#3B526D",
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 306,
    r: 8,
    fill: "#087CFF",
    stroke: "#fff",
    strokeWidth: 3
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 456,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10
  }, "EXPECTED RANGE")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 338,
    y: 456,
    fill: "#FF8DB8",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10
  }, "OBSERVED")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 492,
    width: 342,
    height: 48,
    rx: 13,
    fill: "#0A213D",
    stroke: "#2A4666"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 516,
    r: 5,
    fill: "#30D6A1"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 521,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Evidence linked")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 521,
    fill: "#fff",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "4 / 4")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 554,
    width: 342,
    height: 48,
    rx: 13,
    fill: "#0A213D",
    stroke: "#2A4666"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 578,
    r: 5,
    fill: "#087CFF"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 583,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Distance assessed")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 583,
    fill: "#fff",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "612 km")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 616,
    width: 342,
    height: 48,
    rx: 13,
    fill: "#0A213D",
    stroke: "#2A4666"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 640,
    r: 5,
    fill: "#FF2775"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 645,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Fuel assessed")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 645,
    fill: "#fff",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "84.6 L")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreFuelIntelligenceAnomalyDetectionDashboardMobile);
export default __webpack_public_path__ + "static/media/fleetcore-fuel-intelligence-anomaly-detection-dashboard-mobile.2298b3b520fdcd75e3970b90e78faab2.svg";
export { ForwardRef as ReactComponent };